export const REDUCER_KEY = 'trackOfTheDay';
export const SET_TRACK_OF_THE_DAY = 'SET_TRACK_OF_THE_DAY';
